import { render, staticRenderFns } from "./partner.vue?vue&type=template&id=3753cf11&scoped=true&"
var script = {}
import style0 from "./partner.vue?vue&type=style&index=0&id=3753cf11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3753cf11",
  null
  
)

export default component.exports